import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, Table, TableHeader, TableRow, TableHeaderColumn, TableRowColumn, TableBody, CircularProgress } from "material-ui"
import TF from "material-ui/Table/TableFooter"
import TableFooter from "../../../components/layout/TableFooter"
import * as api from "../../../api"
import strings from "../../../localization/strings"
import { IUserDocument, IUserJobSearch } from "../../../models"
import { IJobQueryFilter } from "./UserDetailsJobs"
import DateRangeSelect from "../../../components/common/DateRangeSelect"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"
import accountStore from "../../../stores/AccountStore"
const activationCodeRegExp = /^[a-zA-Z0-9-]*$/
interface IProps {
    employee: IUserDocument
    handleRequestJob(jobId: string): Promise<void>
    closeDialog(): void
    getUserJobs(): void
}
interface IState {
    name: string
    availableJobs: IUserJobSearch[] /* jobs that the user can request - aka they have the right occupation/specialty/badge */
    activationCode: string
    errorName: string
    errorActivationCode: string
    saveClicked: boolean
    disableException: boolean
    selectedJob: IUserJobSearch | undefined
    loading: boolean
    jobQueryFilter: IJobQueryFilter
    offset: number
    limit: number
}

export default class AddUserDetailRequestedJobDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        let startDate = new Date()
        startDate.setMonth(startDate.getMonth() - 3)
        let endDate = new Date()
        endDate.setMonth(endDate.getMonth() + 3)
        this.state = {
            name: "",
            availableJobs: [],
            activationCode: "",
            errorName: "",
            errorActivationCode: "",
            saveClicked: false,
            disableException: false,
            selectedJob: undefined,
            loading: false,
            jobQueryFilter: {
                EndDate: endDate.toISOString(),
                StartDate: startDate.toISOString()
            },
            offset: 0,
            limit: 50,
        }
        autobind(this)
    }

    componentDidMount() {
        this.getAvailableJobs()
    }

    getAvailableJobs = async () => {
        this.setState({ loading: true }, () => {
            api.searchUserJobs(this.props.employee.Id, {
                AccountId: this.props.employee.AccountId,
                Search: "",
                Page: this.state.offset / this.state.limit,
                Limit: this.state.limit,
                StartDate: this.state.jobQueryFilter.StartDate,
                EndDate: this.state.jobQueryFilter.EndDate,
                Available: true,
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    availableJobs: res.data as IUserJobSearch[],
                    offset: 0.
                })
            })
        })
    }

    detectEnter(event) {
        event.keyCode === 13 && this.handleRequestSave()
    }

    clearState() {
        this.setState({
            name: "",
            activationCode: "",
            errorName: "",
            errorActivationCode: "",
            saveClicked: false,
            disableException: false
        })
    }

    handleRequestSave() {
        this.setState({ saveClicked: true }, () => {
            this.handleRequestJob()
        })
    }

    handleRequestJob() {
        this.props.handleRequestJob(this.state.selectedJob.Id).then((res) => {
            try {
                this.props.getUserJobs()
                this.props.closeDialog()
            } catch (error) {
                this.setState({ errorActivationCode: String(error) })
            }
        })
    }

    handleRowSelect(row) {
        if (this.state.selectedJob && this.state.selectedJob.Id === this.state.availableJobs[row].Id) {
            this.setState({
                selectedJob: undefined
            })
        } else {
            this.setState({
                selectedJob: this.state.availableJobs[row]
            })
        }
    }

    checkValidate() {
        let returnVal = true
        if (this.state.saveClicked && this.state.name.trim().length === 0) {
            this.setState({ errorName: strings.Name_cannot_be_empty })
            returnVal = false
        } else {
            this.setState({ errorName: "" })
        }

        if (this.state.saveClicked && this.state.activationCode.length === 0) {
            this.setState({ errorActivationCode: strings.Registration_code_cannot_be_empty })
            return false
        } else if (!this.state.activationCode.match(activationCodeRegExp)) {
            this.setState({ errorActivationCode: strings.Invalid_registration_code_format })
            returnVal = false
        } else {
            this.setState({ errorActivationCode: "" })
        }
        return returnVal
    }

    handleJobFilterChange = async (filter: IJobQueryFilter) => {
        this.setState({ jobQueryFilter: filter }, () => this.getAvailableJobs())
    }

    render() {
        return (
            <Dialog
                open={true}
                title={ checkJobFieldAvailable('plural') ? `Available ${accountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel}` : strings.Available_Jobs}
                actions={
                    <div>
                        <FlatButton data-intercom-target={"menu-Employees-Jobs-Add-Btn-CloseAddJobDialog"} label={strings.CANCEL} secondary onTouchTap={this.props.closeDialog} />
                        <FlatButton data-intercom-target={"menu-Employees-Jobs-Add-Btn-AddSelectedJob"} disabled={this.state.selectedJob === undefined} label={ checkJobFieldAvailable('singular') ? `Add ${accountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Add_Job} primary onTouchTap={this.handleRequestSave} />
                    </div>
                }
            >
                <DateRangeSelect
                    endDate={this.state.jobQueryFilter.EndDate}
                    startDate={this.state.jobQueryFilter.StartDate}
                    handleChange={(sd, ed) => {
                        this.handleJobFilterChange({
                            EndDate: String(ed),
                            StartDate: String(sd)
                        })
                    }}
                />
                {this.state.loading ? (
                    <div className="spinner">
                        <CircularProgress />
                    </div>
                ) : this.state.availableJobs.length === 0 ? (
                    <h4>{checkJobFieldAvailable('singular') ?`No ${accountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel} Available` : "No Jobs Available"}</h4>
                ) : (
                    <Table multiSelectable={false} selectable={true} onRowSelection={this.handleRowSelect}>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderColumn style={{ textAlign: "center" }}>{ checkJobFieldAvailable('singular') ? `${accountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel} Name` :strings.Job_Name}</TableHeaderColumn>

                            </TableRow>
                        </TableHeader>
                        <TableBody showRowHover={true} deselectOnClickaway={false}>
                            {this.state.availableJobs.map((job) => (
                                <TableRow key={job.Id} selected={this.state.selectedJob && this.state.selectedJob.Id === job.Id ? true : false}>
                                    <TableRowColumn style={{ textAlign: "center" }}>{job.JobName}</TableRowColumn>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TF>
                            <TableFooter
                                total={this.state.availableJobs.length}
                                offset={this.state.offset}
                                limit={this.state.limit}
                                limitOptions={[50,100,200]}
                                onPageClick={(offset) => this.setState({ offset })}
                                onLimitChange={(limit) => this.setState({ limit, offset: 0 })}
                            />
                        </TF>
                    </Table>
                )}
            </Dialog>
        )
    }
}
